import { render, staticRenderFns } from "./SlipPayment.vue?vue&type=template&id=35436e00&scoped=true&"
import script from "./SlipPayment.vue?vue&type=script&lang=js&"
export * from "./SlipPayment.vue?vue&type=script&lang=js&"
import style0 from "./SlipPayment.vue?vue&type=style&index=0&id=35436e00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35436e00",
  null
  
)

export default component.exports